import { Link } from "react-router-dom";
import { CreditCard, Clock, FileSignature } from "lucide-react";

const items = [
  { icon: CreditCard, label: "Paiements Stripe", sub: "Sécurisés & conformes" },
  { icon: Clock, label: "Reversement 24 h", sub: "Après chaque vente" },
  { icon: FileSignature, label: "Contrat transparent", sub: "80 % / 20 %, aucun frais caché" },
];

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white" data-testid="site-footer">
      {/* Trust strip */}
      <div className="border-b border-white/10">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-10 grid sm:grid-cols-3 gap-8">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div key={i} className="flex items-center gap-4" data-testid={`trust-${i}`}>
                <div className="w-11 h-11 flex items-center justify-center border border-white/15 text-[#F97316] shrink-0">
                  <Icon className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-sm font-bold">{it.label}</div>
                  <div className="text-xs text-white/50 font-light">{it.sub}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-12 flex flex-col md:flex-row justify-between gap-8">
        <div>
          <div className="text-2xl font-black tracking-tighter">
            iFoto<span className="text-[#F97316]">Life</span>
          </div>
          <p className="mt-3 text-sm text-white/50 font-light max-w-xs">
            La plateforme qui transforme vos photos de vacances en revenu récurrent.
          </p>
          <p className="mt-4 text-xs text-white/40">Support WhatsApp : +XX XXX XXX XXX</p>
        </div>
        <div className="flex flex-col gap-3 text-sm">
          <a href="https://business.ifotolife.shop" className="text-white/60 hover:text-white transition-colors">Comment ça marche</a>
          <a href="#pourquoi" className="text-white/60 hover:text-white transition-colors">Pourquoi iFotoLife</a>
          <Link to="/contract" className="text-white/60 hover:text-white transition-colors" data-testid="footer-contract-link">
            Contrat de partenariat
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/40">
          <span>© {new Date().getFullYear()} iFotoLife. Tous droits réservés.</span>
          <span>partenaires.ifotolife.shop</span>
        </div>
      </div>
    </footer>
  );
}
